import {
    processGetWacInfoQueue,
    queueGetWacInfo,
    tryQueueGetWacInfo,
} from '../actions/internalActions';
import store from '../store/store';
import getValidDocLinkPreviewInfo from '../utils/getValidDocLinkPreviewInfo';
import { orchestrator } from 'satcheljs';

orchestrator(tryQueueGetWacInfo, actionMessage => {
    const { url } = actionMessage;

    if (
        store.getWacInfoQueue.some(queued => queued === url) ||
        store.activeGetWacInfoOperations.some(active => active === url)
    ) {
        // same URL already in queue or active, do nothing
        return;
    }

    if (store.suppressedUrls.some(suppressed => suppressed === url)) {
        // OWA sent a request for the same URL before but got a permanent error
        // do not try to do the same thing again
        return;
    }

    if (!!getValidDocLinkPreviewInfo(url)) {
        // cached preview info is still valid, do nothing
        return;
    }

    queueGetWacInfo(url);
    processGetWacInfoQueue();
});
